import { loadScript, clearCache, event, getGlobalThis } from "@crystal/core/utils";
import { recaptchaReady } from "./internals.js";
const recaptchaScriptId = "recaptcha-loader-script";
const recaptchaBaseUrl = "https://www.google.com/recaptcha/enterprise.js";
const RECAPTCHA_SCRIPT_TIMEOUT = 2e4;
async function loadRecaptcha(recaptchaSiteKey) {
  if (isRecaptchaReady())
    return Promise.resolve();
  const recaptchaUrl = `${recaptchaBaseUrl}?render=${recaptchaSiteKey}`;
  const promise = loadScript(recaptchaUrl, recaptchaScriptId, {
    disableCrossOrigin: true
  });
  return promise.then(ensureRecaptchaLoaded).catch((err) => {
    clearCache(recaptchaUrl);
    return Promise.reject(err);
  }).then(() => event.emit(recaptchaReady));
}
async function getToken(recaptchaSiteKey, params) {
  var _a;
  if (!isRecaptchaReady()) {
    await loadRecaptcha(recaptchaSiteKey);
  }
  const token = await ((_a = getRecaptcha()) == null ? void 0 : _a.execute(recaptchaSiteKey, params));
  if (!token)
    return Promise.reject(new Error("Invalid token received"));
  return token;
}
function isRecaptchaReady() {
  var _a;
  return !!((_a = getRecaptcha()) == null ? void 0 : _a.execute);
}
function getRecaptcha() {
  var _a;
  const win = getGlobalThis();
  return (_a = win.grecaptcha) == null ? void 0 : _a.enterprise;
}
function ensureRecaptchaLoaded() {
  const recaptcha = getRecaptcha();
  if (!recaptcha)
    return Promise.reject(new Error("Recaptcha is not loaded"));
  if (isRecaptchaReady())
    return Promise.resolve();
  return new Promise((resolve, reject) => {
    const timerId = setTimeout(reject, RECAPTCHA_SCRIPT_TIMEOUT);
    recaptcha.ready(() => {
      clearTimeout(timerId);
      resolve();
    });
  });
}
export {
  getToken,
  isRecaptchaReady,
  loadRecaptcha
};
//# sourceMappingURL=recaptcha.js.map
